module.exports = __webpack_public_path__ + "static/media/Gilmer-Bold.e1976537.otf";